<template>
    <div class="call-card-detail-item-wrapper">

        <div item-wrap v-for="item in list" :wrap-level="item.Level">
            <div item v-if="item.ItemLabel!=''" :class="{'item-photo':item.ItemTypeCode=='photo' && item.PhotoList.length>0}" >
                <div item-label :class="{'isItemGroup':item.Items&&item.Items.length>0}" :level="item.Level">
                    {{item.ItemLabel}}</div>
                <div item-value v-if="(!item.Items||item.Items.length==0) && item.ItemTypeCode!='photo'">
                    {{item.Value || ''}}</div>
                <div item-value="photo" v-if=" item.ItemTypeCode=='photo' && item.PhotoList.length>0"
                    style="display:inline-block;height: 90px; min-width: 60px; overflow: auto;" >
                    <img v-for="(p,index) in item.PhotoList" :src="p.VirtrualPath" alt="" :label="p.ItemLabel" :stime="p.ShotTime"  :cname="p.CustomerName" :caddr="p.Address"
                        style="width:80px;height:50px; object-fit:cover;margin-right: 10px;vertical-align: middle; cursor: pointer;">
                </div>
            </div>

            <div v-if="item.Items&&item.Items.length>0">
                <call-card-detail-item :list="item.Items" :groups="[]"></call-card-detail-item>
            </div>
        </div>

        <div group-wrap v-for="g in groups">
            <div cate class="isModuleGroup" :level="g.Level">{{g.Name}}</div>
            <div cate v-if="g .Children&&g .Children.length>0">
                <call-card-detail-item :list="g .Items" :groups="g.Children"></call-card-detail-item>
            </div>
            <div v-if="g.Items&&g.Items.length>0">
                <call-card-detail-item :list="g.Items" :groups="[]"></call-card-detail-item>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "call-card-detail-item",
        props: {
            list: Array,
            groups: Array,
        },
        data() {
            return {};
        },
        methods: {},
        watch: {}
    };
</script>

<style scoped>
    [cate] {
        font-weight: 600;
        padding: 10px 0;
    }

    [item] {
        font-weight: 500;
        border-bottom: 1px solid #eee;
        font-size: 12px;
        height: 25px;
        line-height: 25px;
    }

    [item-label] {
        display: inline-block;
        width: 50%;
        min-height: 25px;
        line-height: 25px;
    }

    [item-value] {
        display: inline-block;
        width: 40%;
        float: right;
    }


    [level='0'] {
        padding-left: 90px;
    }

    [level='1'] {
        /* color: #238fff; */
        font-weight: 600;
        font-size: 14px;
        color: #fff;
        padding-left: 5px;
        background: -webkit-linear-gradient(0deg, #55a2f3, #fff);
    }

    [level='2'] {
        padding-left: 20px;
        color: #24a9d5;
        background: -webkit-linear-gradient(0deg, aliceblue, #fff);
    }

    [level='3'] {
        padding-left: 40px;
        color: #195254;
        background: -webkit-linear-gradient(0deg, #f9fcff, #fff);
    }

    [level='4'] {
        padding-left: 60px;
        color: #23cca5;
    }

    .isModuleGroup {
        color: #000;
        font-weight: 600;
        font-size: 14px;
    }

    .isModuleGroup[level='1'] {
        padding-left: 10px;
        color: #fff;
        background: -webkit-linear-gradient(0deg, #238fff, #fff);
        margin-top: 10px;
    }

    .isModuleGroup[level='2'] {
        padding-left: 20px !important;
        color: #24a9d5  !important;
        background-color: aliceblue  !important;
        margin-left: 0 !important;
    }

    .isModuleGroup[level='3'] {
        padding-left: 40px;
        color: #23c4cc;
        background-color: #f9fcff;

    }

    .isModuleGroup[level='4'] {
        padding-left: 60px;
        color: #23cca5;
    }

    [cate] [level='2'] {
        margin-left: 120px;
        padding-left: 5px;
        max-width: 200px;
    }

    .item-photo{
        height: 90px;
    }

    .item-photo>div{
        height: 90px;
        line-height: 90px;
    }


</style>


// WEBPACK FOOTER //
// src/components/customComponents/call-card-detail-item/call-card-detail-item.vue